// Form Scripts & Validation

$(function(){	
	// Validate ZIP
	if ($('.validate_zip').length){
        // zip input present
        
        $('.validate_zip input').on('blur', function(){
            var $zip_input = $(this),
                $zip_input_parent = $zip_input.parents('.validate_zip'),
                $zip_input_regex = $zip_input.attr('data-pattern');

            if ($(this).val() && $zip_input_regex.length) {
                // not empty
                let regex = new RegExp($zip_input_regex);

                if (regex.test($zip_input.val())){
                    // valid
                    $zip_input_parent.removeClass('invalid');
                }  else {
                    // invalid
                    $zip_input_parent.addClass('invalid');
                }
            } else {
                // empty
                $zip_input_parent.removeClass('invalid');
            }
        });
	}
	
	//---------- UNIVERZAL SUBMIT FORM JS -----------------
	function submitForm(form, e) {
		e.preventDefault();
		if (!validateRequiredFields(form)) {
			return;
		}
		const submitBtn = form.find('button[type="submit"]');	
		// create loading
		submitBtn.attr('disabled', true).addClass('loading').append(`<span class="skeleton__loader skeleton__loader--button"></span>`);
		
		if(typeof recaptcha_site_key_v3 !== undefined && recaptcha_site_key_v3 !== undefined) {
			grecaptcha.ready(function() {
				grecaptcha.execute(recaptcha_site_key_v3,{
				action: recaptcha_action
			}).then(function(token) {
				if (token) {
						form.find('[name="recaptcha"]').val(token);
						form.find('#recaptcha-error').addClass('d-none');
						
						// Send Valid forms to BE & validate
						var params = form.serialize();
						$.ajax({													
							method: 'POST',
							url: cyclone3.domain + '/json/' + cyclone3.lng + '/' + form.data('service'),
							data: params									
						}).done(function(e) {
							
							form.find('.form_item').removeClass('invalid');
							form.removeClass("form-server-error");
					
							// if success   
						   if (e.success == true) {
								if (e.redirect_url){
									window.location.replace(e.redirect_url);
								} else {                                                								
									form.addClass("form-success");
									$('.notification .notification--success__button').on('click', function() {
										cleanForm(form);
										form.removeClass("form-success");
									});
								}								
							} else  {    
								$.each(e.invalid, function( index, errorName ) {
									if (errorName == "recaptcha") {                
										form.find('#recaptcha-error').removeClass('d-none');
									} else {
										form.find('[name="' + errorName + '"]').closest('.form_item').addClass('invalid'); 
									}
								});
							} 
						})
						.fail(function() {
							form.addClass("form-server-error");
						});
						
					} else {
						form.find('#recaptcha-error').removeClass('d-none');
					}
				});
			});
		}
		// remove loading
		submitBtn.prop('disabled', false).removeClass('loading').find('.skeleton__loader').remove();
    }
	
	
	function validateRequiredFields(form) {
		let isValid = true;

		form.find('[required]').each(function() {
			const $field = $(this);
			const fieldType = $field.attr('type');
			const value = $field.val().trim();
			
			if (!value) {
				isValid = false;
				addErrorInput($field);
				return;
			} else {				
				removeErrorInput($field);
			}
			
			switch (fieldType) {
				case 'email':
					const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
					if (!emailRegex.test(value)) {
						isValid = false;
						addErrorInput($field);
					} else {
						removeErrorInput($field);
					}
					break;
				case 'phone':
						if ($field.closest('.form_item').hasClass('valid')) {
							removeErrorInput($field);
						} else {					
							isValid = false;
							addErrorInput($field);
						}
						break;
				case 'checkbox':
					if ($field.prop('checked') && $field.closest('.form_item').hasClass('checked')) {						
						removeErrorInput($field);
					} else {
						isValid = false;
						addErrorInput($field);
					}
					break;
				default:
					break;
			}
		});
		return isValid;
	}

	function addErrorInput(el) {
		el.closest('.form_item').addClass('invalid');
	}

	function removeErrorInput(el) {
		el.closest('.form_item').removeClass('invalid');
	}
	
	function cleanForm (form){
		form.find('input:not([type="hidden"],[readonly]),textarea').each(function(){
			$(this).val('');
		});
		form.find('.form_item.checkbox').each(function(){
			$(this).removeClass('checked').find('input[type="checkbox"]').prop('checked', false);
		});		
		form.find('select').each(function(){
			$(this)[0].selectedIndex = 0;
		});
	}   
	
	const $forms = $('.form_request');

	if ($forms.length) {
		$forms.on('submit', function (e){
			submitForm($(this), e);
		});
	}
});